import { render, staticRenderFns } from "./FormCustomerDocument.vue?vue&type=template&id=b3d2c1ce&scoped=true"
import script from "./FormCustomerDocument.vue?vue&type=script&lang=js"
export * from "./FormCustomerDocument.vue?vue&type=script&lang=js"
import style0 from "./FormCustomerDocument.vue?vue&type=style&index=0&id=b3d2c1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d2c1ce",
  null
  
)

export default component.exports